<div class="statistics-menu">
  <dv-dynamic-form
    class="dynamic-form"
    [elements]="elements | translateElements"
    [formGroup]="formGroup">
  </dv-dynamic-form>
  <app-pinned-groups-area
    class="statistics-menu__selected-groups"
    [selectedGroups]="statisticsMenuService.pinnedGroups$ | async"
    (removeSelection)="onRemoveSelectionClick($event)"></app-pinned-groups-area>
</div>
